export const DataTypesOfScheduling = (type: number) => {
    switch (type) {
        case 1:
            return 'Instalação';
        case 2:
            return 'Desinstalação';
        case 3:
            return 'Instalação de Troca';
        case 4:
            return 'Desinstalação de Troca';
        case 5:
            return 'Agendamento de Visita';
        case 6:
            return 'Reagendamento de Visita';
        case 7:
            return 'Troca Assistência Técnica';
        case 8:
            return 'Motoboy';
        case 9:
            return 'Revisão';
        case 10:
            return 'Troca Equipamento';
        case 11:
            return 'Vistoria';
        case 12:
            return 'Vistoria Fotos';
        case 13:
            return 'Revisão Plataforma';
        default:
            return '';
    }
}